module.exports = __webpack_public_path__ + "static/img/blue-house.6e573c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/blue-house.jpg
// module id = +PN/
// module chunks = 0